import { StepModel } from "../../../common/components/dotLegalStepper/DotLegalCoreStepper.types";
import { useSteps } from "../../../common/components/dotLegalStepper/useSteps";
import { ContractModel } from "../Contract.types";
import { EntityTemplate } from "../../../entityTemplates/EntityTemplate.types.ts";
import { getFieldValue } from "../ContractValidator.hooks.ts";
import { hasFieldData } from "../../../entityTemplates/fieldValue.ts";

export function useContractSteps(contract: ContractModel, contractTemplate: EntityTemplate | undefined, contractSteps: Array<StepModel>) {
    const steps = useSteps(contract, contractSteps, "step", HasStepDataAdded);

    function HasStepDataAdded(step: number) {
        if (!contractTemplate) {
            return false;
        }
        const contractTemplateStep = contractTemplate.steps.find((x) => x.order === step);

        return !!contractTemplateStep?.fields.some((field) => hasFieldData(getFieldValue(field, contract, [])));
    }

    return {
        getSteps: steps.getTemplateSteps,
        getActiveStep: steps.getActiveStep,
        changeStep: steps.changeStep,
        validationErrors: steps.validationErrors,
    };
}
